import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-navy text-cream border-t border-cream/15 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div>
          <p className="font-serif text-3xl">
            The French Atelier <span className="italic text-gold">by Cécile</span>
          </p>
          <p className="text-cream/50 text-sm mt-3 max-w-sm leading-relaxed">
            Private French lessons — children, teens, adults and
            professionals. Houston area · Online.
          </p>
          <div className="mt-5 space-y-2 text-sm text-cream/70">
            <a href="mailto:cecilekinnunen@gmail.com" className="flex items-center gap-2 hover:text-cream transition-colors" data-testid="footer-email-link">
              <Mail size={14} className="text-gold" /> cecilekinnunen@gmail.com
            </a>
            <a href="tel:+15619550794" className="flex items-center gap-2 hover:text-cream transition-colors" data-testid="footer-phone-link">
              <Phone size={14} className="text-gold" /> (561) 955-0794
            </a>
          </div>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-cream/70">
          <button onClick={() => onNavigate("#services")} className="link-underline" data-testid="footer-link-services">Lessons</button>
          <button onClick={() => onNavigate("#cecile")} className="link-underline" data-testid="footer-link-cecile">Cécile</button>
          <button onClick={() => onNavigate("#formules")} className="link-underline" data-testid="footer-link-formats">Formats</button>
          <button onClick={() => onNavigate("#contact")} className="link-underline" data-testid="footer-link-contact">Contact</button>
          <Link to="/admin" className="link-underline text-cream/40" data-testid="footer-admin-link">Cécile's Space</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-10 pt-6 border-t border-cream/10 text-xs text-cream/40 flex flex-wrap justify-between gap-3">
        <span>© 2026 The French Atelier by Cécile</span>
        <span className="italic font-serif text-sm text-gold/70">See you very soon!</span>
      </div>
    </footer>
  );
}
